export default __webpack_public_path__ + "media/images/services-04-350x220-d023bf74dd4515d4a83f33441c66b584.jpg";